import { STRINGS } from '../../constants';
import apiCaller from '../http';
import URLS from '../urls';

export const fetchVisitsForDate = async (profileId, value, setError, saveVisits, logoutHandler) => {
  const now = new Date();
  const today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
  const payload = {
    day: value?.day ?? today.getDate(),
    month: (value?.month ?? today.getMonth()) + 1,
    year: value?.year ?? today.getFullYear(),
  };
  await apiCaller
    .get(`${URLS.VISITS_FOR_DATE_BY_WORKSHOP_PROFILE}${profileId}/`, {
      params: payload,
    })
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        saveVisits(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400TextRead);
      }
      setError(STRINGS.common.error404Text);
    });
};

export const fetchVisitsOngoing = async (profileId, setError, saveVisits, logoutHandler, token) => {
  await apiCaller
    .get(`${URLS.VISITS_ONGOING_BY_WORKSHOP_PROFILE}${profileId}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        saveVisits(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400TextRead);
      }
      setError(STRINGS.common.error404Text);
    });
};

export const fetchVisitsUnscheduled = async (
  profileId,
  setError,
  saveVisits,
  logoutHandler,
  token,
) => {
  await apiCaller
    .get(`${URLS.VISITS_UNSCHEDULED_BY_WORKSHOP_PROFILE}${profileId}/`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
    .then((response) => {
      if (response.data !== undefined) {
        setError(null);
        saveVisits(response.data);
      } else {
        setError(STRINGS.common.error404Text);
      }
    })
    .catch((e) => {
      if (e.message === STRINGS.common.errorMissingCredentials) {
        logoutHandler();
      }
      if (e.message === STRINGS.common.error400Template) {
        setError(STRINGS.common.error400TextRead);
      }
      setError(STRINGS.common.error404Text);
    });
};
